// const production = false;
// const ID = 'servitravel';
// const APP_NAME = 'Servitravel';
// const GOOGLE_MAP_KEY = 'AIzaSyCaw8ahy7ztFKt6aqxxxxxxxxxxxxxxxxxx';
// const GOOGLE_RECAPTCHA_SITEKEY = '6LdGty4UAAAAACrpeTUV7sQGFxxxxxxxxxxxx';
// const DEVELOPMENT = {
//     PRODUCTION: false,
//     ID: ID,
//     APP_NAME: APP_NAME,
//     SITE: 'https://www.servitravel.com.py',//sitio web
//     HOST: 'http://192.168.1.86/servitravel',//localhost
//     BASENAME: '/servitravel',//subdirectorio del host
//     URL_BASE: 'http://localhost/servitravel.com.py/admin/api',//api
//     GOOGLE_MAP_KEY: GOOGLE_MAP_KEY,
//     GOOGLE_RECAPTCHA_SITEKEY: GOOGLE_RECAPTCHA_SITEKEY,
//     LOGS: true
// }
// // const PRODUCTION = {
// //     PRODUCTION: true,
// //     ID: ID,
// //     APP_NAME: APP_NAME,
// //     SITE: 'http://192.168.1.86/servitravel.com.py',//sitio web
// //     HOST: 'http://192.168.1.86/servitravel',//production (copiar y pegar en package.json --> homepage)
// //     BASENAME: '/servitravel',//subdirectorio
// //     URL_BASE: 'http://192.168.1.86/servitravel.com.py/admin/api',//api
// //     GOOGLE_MAP_KEY: GOOGLE_MAP_KEY,
// //     GOOGLE_RECAPTCHA_SITEKEY: GOOGLE_RECAPTCHA_SITEKEY,
// //     LOGS: true
// // }
// const PRODUCTION = {
//     PRODUCTION: true,
//     ID: ID,
//     APP_NAME: APP_NAME,
//     SITE: 'https://www.servitravel.com.py',//sitio web
//     HOST: 'https://www.servitravel.com.py/react',//production (copiar y pegar en package.json --> homepage)
//     BASENAME: '/react',//subdirectorio
//     URL_BASE: 'https://www.servitravel.com.py/admin/api',//api
//     GOOGLE_MAP_KEY: GOOGLE_MAP_KEY,
//     GOOGLE_RECAPTCHA_SITEKEY: GOOGLE_RECAPTCHA_SITEKEY,
//     LOGS: true
// }
// export default (production) ? PRODUCTION : DEVELOPMENT;

const production = false;
const url = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
// const url = 'http:' + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
let base = url.replace(':3000', '');
base = base.replace(':3001', '');
base = base.replace(':3002', '');

let API_URL = base + '/api';
let SITE = base;
let BASENAME = '/';

console.log('window.location.hostname', window.location.hostname);
console.log('API_URL', API_URL);

if (window.location.hostname === '192.168.2.120') {
    API_URL = base + '/servitravel/api';
    SITE = base + '/servitravel';
    BASENAME = '/servitravel';
}
if (window.location.hostname === 'localhost') {
    API_URL = base + '/servitravel/api';
   // BASENAME = '/www.servitravel.com.py';
    BASENAME = '/servitravel';
}
if (window.location.hostname === '192.168.1.33') {
    API_URL = base + '/www.servitravel.com.py/api';
    BASENAME = '/servitravel.com.py';
}

const CONFIG = {
    ID: 'servitravel',
    APP_NAME: 'servitravel',
    SITE: SITE,//sitio web
    HOST: SITE,//production (copiar y pegar en package.json --> homepage)
    BASENAME: BASENAME,//subdirectorio
    API_URL: API_URL,//api
    LOGS: !production
}
export default CONFIG;
